import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as history from "app/main/history";

import { columnas } from "./columns";
import { createSelector } from "keautils";
import { Multiselector } from "app/features/componentes/multiselector";

export interface Props {
    /**Folios de las guias seleccionadass¿ */
    value: string[];
    onChange: (value: string[]) => void;
    items: models.GuiaCobranzaDto[];
    hideBusqueda?: boolean;
    label?: string;
}


/**Multiselector de las guias, lo unico que muestra es el grid, no muestra los filtros ni ninguna otra cosa  */
export class MultiselectorGuiaCobranza extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    items = (props: Props) => props.items;
    
    onVer = (guia: models.GuiaCobranzaDto) => {
        history.go("/operativa/guias/" + guia.Folio);
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                {this.props.label && <kea.Title titulo={this.props.label} size="h4"  />}
                <Multiselector
                     cookieKey="multiselectorGuiasCobranza" 
                     items={this.items(this.props)} 
                     columnas={cols}
                      hideBusqueda={this.props.hideBusqueda} 
                      value={this.props.value}
                      onChange={this.props.onChange}
                      getKey={x => x.Folio}
                    />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibos/guias/index.tsx